import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Popconfirm, Select, Space, Tooltip } from '@retail-core/rds';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useStore } from '../StoreContext/StoreContext';
import { CgGroupingLevel } from '../../models/sizing-group';
import './GroupLevelSelect.less';

const { Option } = Select;

export const GroupLevelSelect: FC = observer(() => {
  const { sizing, uiStore } = useStore();
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [pendingLevel, setPendingLevel] = useState<CgGroupingLevel | null>(null);

  const readOnly = sizing.readOnly;

  const handleSelectChange = (level: CgGroupingLevel) => {
    setPendingLevel(level);
    setConfirmVisible(true);
  };

  const handleConfirm = async () => {
    setConfirmVisible(false);
    if (!pendingLevel) return;
    if (uiStore.searchQuery) {
      uiStore.searchArticles('');
    }
    try {
      await sizing.changeGroupingLevel(pendingLevel);
    } finally {
      setPendingLevel(null);
    }
  };

  const handleCancel = () => {
    setConfirmVisible(false);
    setPendingLevel(null);
  };

  // @ts-ignore
  return (
    <Space className="cg-dropdown">
      Set CG level for sizing
      <Popconfirm
        visible={confirmVisible}
        title="The persisted sized quantities will be updated"
        placement="bottomLeft"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        okText="Yes, change CG level"
        cancelText="Cancel"
        overlayClassName="change-cg-level-confirm"
      >
        <Select
          value={sizing.groupingCgLevel}
          onChange={handleSelectChange}
          size="small"
          virtual={false}
          disabled={readOnly}
        >
          <Option value={CgGroupingLevel.CG5}>5</Option>
          <Option value={CgGroupingLevel.CG4}>4</Option>
          <Option value={CgGroupingLevel.CG3}>3</Option>
        </Select>
      </Popconfirm>
      <Tooltip
        placement="top"
        title="Pick a higher CG level for more precise sizing, or a lower CG level for faster sizing in bulk"
      >
        {/* @ts-ignore */}
        <InfoCircleOutlined />
      </Tooltip>
    </Space>
  );
});
